import { RootState } from "../Store";

export const hasPermission = (state: RootState, screenName: string, permission: string): boolean => {
  const screen = state.permission.permissions.find(p => p.screen_name === screenName);
  return screen ? screen.permissions.includes(permission) : false;
};